import React, { SyntheticEvent } from 'react'
import Tooltip from 'components/Tooltip'

import BusinessSource from 'components/BusinessSource'
import { camelCase } from 'lodash'
import Icon from 'components/Icon'
import cx from 'classnames'
import styles from './EmployeeCard.scss'

export interface IEmployee {
  name?: string
  title?: string
  location?: string
  photoUrl?: string
  profileUrl?: Array<string> | null
  profileUrls?: Array<string> | null
  email?: string
  isVerified?: boolean
  tin?: string
}

export default function EmployeeCard({
  name,
  title,
  location,
  photoUrl,
  profileUrl = [],
  email,
  isVerified,
}: IEmployee) {
  const photo = photoUrl || require('./assets/avatar.png')

  const renderSources = () => {
    if (!profileUrl || profileUrl.length === 0) return
    return profileUrl.map(url => {
      const parts = url.split('.')
      if (parts.length < 2) return null

      const socialMediaName = parts[1]
      return (
        <a key={url} href={url} target='_blank' rel='noreferrer'>
          <BusinessSource source={camelCase(socialMediaName)} isClickable className={styles.svg} />
        </a>
      )
    })
  }

  const onError = (ev: SyntheticEvent<HTMLImageElement>) => {
    ;(ev.target as HTMLInputElement).src = require('./assets/avatar.png')
    return true
  }

  return (
    <div className={styles.container}>
      <div className={styles.inner}>
        <section className={styles.social}>
          <div className={cx(styles.imageContainer, { [styles.verifiedAvatarContainer]: isVerified })}>
            <img src={photo} onError={onError} className={styles.avatar} alt='' />
            {isVerified && <Icon className={styles.verifiedIcon} name='verified-filled' size='medium' />}
          </div>
          <div className={styles.dataSources}>{renderSources()}</div>
        </section>
        <div className={styles.details}>
          <span className={cx(styles.name, { [styles.boldName]: isVerified })}>
            {name && (
              <Tooltip title={name}>
                <>{name}</>
              </Tooltip>
            )}
          </span>
          {title && (
            <span className={styles.title}>
              <Tooltip title={title}>
                <>{title}</>
              </Tooltip>
            </span>
          )}
          {email && !title && (
            <span className={styles.email}>
              <Tooltip title={email}>
                <>{email}</>
              </Tooltip>
            </span>
          )}
          {!email && !title && <span className={styles.title} />}
          {location && (
            <span className={styles.address}>
              From <span className={styles.bold}>{location}</span>
            </span>
          )}
          {!location && <span className={styles.address} />}
        </div>
      </div>
    </div>
  )
}
